import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Service
import { UserInsertService } from '../../service/user-insert/user-insert.service';

@Component({
	selector: 'app-user-insert',
	templateUrl: './user-insert.component.html',
	providers: [
		UserInsertService,
		HttpModule
	]
})
export class UserInsertComponent implements OnInit {
	cadUser: FormGroup;
	private token;
	public users: any[];
	public userGroup: any[] = [];
	public userGroupChecked: any[] = [];
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private userInsertService: UserInsertService, private router: Router, private flashMessagesService: FlashMessagesService) {
		this.token = localStorage.getItem('yara.token');
		this.cadUser = fb.group({
		  'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
		  'opcaoLogin': '',
		  'Login': '',
		  'Status': '',
		  'Email': '',
		  'EmpresaID':'Y',
		  'Grupo': this.userGroupChecked[0],
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.userInsertService.listGroup(this.token).subscribe(result => {
			this.userGroup = result.Result;
			this.userGroupChecked = [];
		}, error => {
			console.log(error);
			
		})
	}

	nameCreateUser: string = "";
	userTipoAcesso: number = 1;
	loginCreateUser: string = "";
	statusCreateUser: boolean = true;
	mailCreateUser: string = "";

	insertUser(value: any) {
		// PEGA TIPO ACESSO
		if ($("#optADCreateUser").is(":checked")) {
			this.userTipoAcesso = 1;
		}
		if ($("#optSFCreateUser").is(":checked")) {
			this.userTipoAcesso = 2;
		}

		// PEGA STATUS ATIVO/INATIVO
		if ($("#statusCreateUser").is(":checked")) {
			this.statusCreateUser = true;
		} else {
			this.statusCreateUser = false;
		}

		var objUser = {
			Nome: value.Nome,
			TipoAcesso: this.userTipoAcesso,
			Login: value.Login,
			Email: value.Email,
			EmpresasID: value.EmpresaID,
			Ativo: this.statusCreateUser,
			Grupos: []
		};

		var ListGroups = this.userGroup.filter(opt => opt.checked).map(opt=>opt.ID);
		for(let obj of ListGroups) {
			objUser.Grupos.push({ ID: obj.toString(), Ativo:true})
		}

		this.userInsertService.insertUser(this.token, objUser).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Usuário editado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/usuarios');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		},
		error => {
			console.log(error);
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/usuarios');
	}

}



// WEBPACK FOOTER //
// ./src/app/user/component/user-insert/user-insert.component.ts